<template>
  <div class="loading-container">
    <div class="loading-effect">
      <div class="circle-container">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
        <div class="circle circle-3"></div>
        <div class="circle circle-4"></div>
      </div>
      <div class="pulse-ring"></div>
    </div>
    
    <p class="loading-message">{{ loadingMessages[currentMessageIndex] }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingAnimation',
  data() {
    return {
      currentMessageIndex: 0,
      messageInterval: null,
      loadingMessages: [
        "Loading...",
        "Almost ready..."
      ]
    }
  },
  mounted() {
    // 消息轮换
    this.messageInterval = setInterval(() => {
      this.currentMessageIndex = (this.currentMessageIndex + 1) % this.loadingMessages.length;
    }, 1000);
  },
  beforeUnmount() {
    clearInterval(this.messageInterval);
  }
}
</script>

<style lang="scss" scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(240,240,250,0.5) 0%, rgba(240,240,250,0) 60%);
    animation: rotate-bg 30s linear infinite;
  }
}

.loading-effect {
  position: relative;
  width: 60px;
  height: 60px;
  margin-bottom: 25px;
  z-index: 1;
}

.circle-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: rotate 2s linear infinite;
}

.circle {
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--primary-color, #4a6cf7);
  box-shadow: 0 0 15px rgba(74, 108, 247, 0.5);
  
  &.circle-1 {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    animation: pulse 1.5s ease-in-out infinite;
  }
  
  &.circle-2 {
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    animation: pulse 1.5s ease-in-out infinite 0.4s;
  }
  
  &.circle-3 {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    animation: pulse 1.5s ease-in-out infinite 0.8s;
  }
  
  &.circle-4 {
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    animation: pulse 1.5s ease-in-out infinite 1.2s;
  }
}

.pulse-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  border: 2px solid rgba(74, 108, 247, 0.4);
  border-radius: 50%;
  animation: pulse-ring 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}

.loading-message {
  color: #333;
  font-size: 0.9rem;
  min-height: 18px;
  transition: opacity 0.5s ease;
  animation: fadeInOut 1s infinite;
  letter-spacing: 1px;
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotate-bg {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1) translateX(-50%);
    opacity: 1;
  }
  50% {
    transform: scale(1.3) translateX(-40%);
    opacity: 0.7;
  }
}

@keyframes pulse-ring {
  0% {
    transform: translate(-50%, -50%) scale(0.7);
    opacity: 0.3;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0;
  }
}

@keyframes fadeInOut {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .loading-effect {
    width: 50px;
    height: 50px;
    margin-bottom: 20px;
  }
  
  .circle {
    width: 10px;
    height: 10px;
  }
  
  .pulse-ring {
    width: 25px;
    height: 25px;
  }
  
  .loading-message {
    font-size: 0.8rem;
  }
}
</style> 